/**
 * Layout wrapper: max-width column, safe-area padding, survey background.
 * @agentic members
 */

import type { ReactNode } from "react";

import styles from "./SurveyShell.module.css";

type SurveyShellProps = {
  children: ReactNode;
};

/**
 * Centers survey content with mobile-first padding and surface styling.
 * @agentic members
 */
export const SurveyShell = ({ children }: SurveyShellProps) => (
  <div className={styles.root}>
    <div className={styles.inner}>{children}</div>
  </div>
);
